const BASE_URL = "https://api.shubhamraj01.in";

export const loginUser = async (email, password) => {
  const response = await fetch(`${BASE_URL}/auth/signin`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email, password }),
  });
  if (!response.ok) {
    const err = await response.json();
    throw new Error(err.message || "Login failed");
  }
  return response.json();
};

export const signupUser = async (fullName, email, password, role) => {
  const response = await fetch(`${BASE_URL}/auth/signup`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ fullName, email, password, role }),
  });
  if (!response.ok) {
    const err = await response.json();
    throw new Error(err.message || "Signup failed");
  }
  return response.json();
};